<template>
	<div>
		<!-- {{date1}} -->
		<div class="row align-items-center">
			<div class="col-auto">
				<div style="width: 200px;">
					<b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1"
					class="mb-0" today-button close-button locale="zh"></b-form-datepicker>
				</div>
			</div>
			<div class="col-auto">
				<b-form-checkbox v-model="showReason" switch size="sm" class="mb-0">涨停原因</b-form-checkbox>
			</div>
			<div class="col-auto">
				<b-form-checkbox v-model="showMarket" switch size="sm" class="mb-0">行情</b-form-checkbox>
			</div>
			<div class="col-auto d-md-none">
				<b-form-checkbox v-model="showMinChart" switch size="sm" class="mb-0">分时</b-form-checkbox>
			</div>
			<div class="col-auto">
				<b-button size="sm" @click="downloadData" variant="outline-primary" class="mb-0">下载</b-button>
			</div>
		</div>

		<div class="row alert-primary border d-none d-md-flex">
			<div class="col col-p-0 uplimit_reason_title">名称</div>
			<div class="col col-p-0 uplimit_reason_title">代码</div>
			<div class="col col-p-0 uplimit_reason_title">时间</div>
			<div class="col col-p-0 uplimit_reason_title">板高</div>
			<div class="col col-p-0 uplimit_reason_title">封单额</div>
			<div class="col col-p-0 uplimit_reason_title">成交额</div>
			<div class="col col-p-0 uplimit_reason_title">实流通</div>
			<div class="col col-p-0 uplimit_reason_title">实换手</div>
			<div class="col col-p-0 uplimit_reason_title">题材</div>
		</div>

		<!-- Mobile Navigation Bar -->
		<div class="d-md-none mobile-nav-bar border-bottom mb-2" v-if="uplimit_reason && uplimit_reason.length" ref="mobileNavBar">
			<div class="mobile-nav-item" 
				:class="{active: idx===activePlateIdx}" 
				v-for="(plate, idx) in uplimit_reason" 
				:key="'mob-nav-' + idx" 
				ref="mobileNavItems"
				@click="scrollToPlate(idx)">
				{{plate.plate_name}} <small>({{plate.stocks.length}})</small>
			</div>
		</div>

		<!-- Mobile Header -->
		<div class="row alert-primary border d-flex d-md-none text-center small font-weight-bold" style="font-size: 12px;">
			<div class="col-3 p-1 border-right">股票</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">时间</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">封单</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">成交</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">换手</div>
			<div class="col p-1">题材</div>
		</div>

		<div v-if="loading" class="d-flex align-items-center p-2">
			<b-spinner small class="mr-2"></b-spinner>
			<span>载入中...</span>
		</div>

        <div v-bind:key="plate.plate_name + ':' + idx" v-for="(plate, idx) in uplimit_reason">
            <div class="row alert-danger border align-items-center plate-header" :id="'plate-' + idx">
                <span class="uplimit_reason_plate">{{plate['plate_name']}} </span>
                <span class="badge badge-pill badge-danger ur-badge">{{plate['stocks'].length}}</span>
                <span class="uplimit_reason_plate">个</span>
            </div>
			<!-- <div class="row"> -->
                <div class="row border uplimit_reason_row" :data-stock-code="stocks.stock_code" v-bind:key="plate.plate_name + '-' + stocks.stock_code" v-for="stocks in sortedStocks(plate)">
					<div class="col p-0">
						<!-- Desktop View -->
						<div class="d-none d-md-block">
							<div class="row uplimit_reason m-0">
								<div class="col border col-p-0 uplimit_reason-item">
									<div>{{stocks['stock_name']}}<span v-if="stocks['market_type'].length>0" class="badge badge-pill badge-danger ur-badge">{{stocks['market_type'].substring(0,1)}}</span><span v-if="showMarket && marketData[stocks['stock_code']] !== undefined" :class="getMarketColor(marketData[stocks['stock_code']])" class="ml-1 small font-weight-bold">{{ marketData[stocks['stock_code']] }}%</span></div>
								</div>
								<div class="col border col-p-0 uplimit_reason-item">
									<div v-b-toggle.sidebar-right-stock @click="show_sidebar(stocks)" class="cursor-pointer">{{stocks['stock_code']}}</div>
								</div>
								<div class="col border col-p-0 uplimit_reason-item">{{stocks['up_limit_time']}}</div>
								<div v-if="stocks['up_limit_keep_times']>=3" class="col border col-p-0 text-danger uplimit_reason-item">{{stocks['up_limit_desc']}}</div>
								<div v-else-if="stocks['up_limit_keep_times']>1" class="col border col-p-0 text-primary uplimit_reason-item">{{stocks['up_limit_desc']}}</div>
								<div v-else class="col border col-p-0 uplimit_reason-item">{{stocks['up_limit_desc']}}</div>
								
								<div class="col border col-p-0 uplimit_reason-item">{{new Number(stocks['fengdan_money'] / 100000000).toFixed(2)}}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{new Number(stocks['amount']).toFixed(2)}}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{new Number(stocks['actualcirculation_value'] / 100000000).toFixed(2)}}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{ amount_display(stocks) }}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{ theme(stocks) }}</div>
							</div>
							<div class="row text-secondary m-0" v-if="showReason">
								<div class="col border col-p-0 uplimit_reason_text">{{stocks['reason']}}</div>
							</div>
						</div>

						<!-- Mobile View -->
						<div class="d-md-none d-flex border-bottom align-items-center text-center small mobile-stock-row" @click="show_sidebar(stocks)" v-b-toggle.sidebar-right-stock style="font-size: 12px;">
							<!-- 股票 -->
							<div class="col-3 p-1 border-right text-left d-flex flex-column justify-content-center" style="min-height: 40px;">
								<div class="font-weight-bold text-truncate">{{stocks['stock_name']}}<span v-if="stocks['market_type'] && stocks['market_type'].length>0" class="stock-market-tag">{{stocks['market_type'].substring(0,1)}}</span><span v-if="showMarket && marketData[stocks['stock_code']] !== undefined" :class="getMarketColor(marketData[stocks['stock_code']])" class="ml-1 small">{{ marketData[stocks['stock_code']] }}%</span></div>
								<div class="text-muted d-flex align-items-center" style="font-size: 10px;">
									<span>{{stocks['stock_code']}}</span>
									<span v-if="stocks['up_limit_keep_times']>=3" class="badge badge-danger ml-1 p-0 px-1 scale-8">{{stocks['up_limit_desc']}}</span>
									<span v-else-if="stocks['up_limit_keep_times']>1" class="badge badge-primary ml-1 p-0 px-1 scale-8">{{stocks['up_limit_desc']}}</span>
									<span v-else class="badge badge-secondary ml-1 p-0 px-1 scale-8 first-board-badge">{{stocks['up_limit_desc']}}</span>
								</div>
							</div>
							<!-- 时间 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{stocks['up_limit_time']}}
							</div>
							<!-- 封单 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{new Number(stocks['fengdan_money'] / 100000000).toFixed(2)}}
							</div>
							<!-- 成交 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{new Number(stocks['amount']).toFixed(2)}}
							</div>
							<!-- 换手 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{ amount_display(stocks) }}%
							</div>
							<!-- 题材 -->
							<div class="col p-1 text-left" style="line-height: 1.2;">
								<div class="text-truncate-2">{{ theme(stocks) }}</div>
							</div>
						</div>
						<div v-if="showReason" class="d-md-none p-2 border-bottom small text-left text-secondary" style="font-size: 11px; background-color: #f8f9fa;">
							{{stocks['reason']}}
						</div>
						<div v-if="showMinChart" class="d-md-none mobile-min-chart-placeholder border-bottom" :data-stock-code="stocks.stock_code" style="min-height: 100px;">
							<stock-mini-trend 
								v-if="visibleStocks[stocks.stock_code]" 
								:symbol_code="stocks.stock_code" 
								:selected_date="date1"
								chart_heigh="100px"
							></stock-mini-trend>
							<div v-else class="d-flex justify-content-center align-items-center" style="height: 100px; background: #f8f9fa;">
								<span class="text-muted small">载入中...</span>
							</div>
						</div>
					</div>
				</div>
			<!-- </div> -->
			
        </div>

		<div class="text-center p-3" v-if="!loading && hasMore">
			<b-button variant="outline-primary" @click="loadData" :disabled="loadingMore" size="sm">
				{{ loadingMore ? '载入中...' : '加载更多' }}
			</b-button>
		</div>
		<div class="text-center p-3 text-muted" v-if="!loading && !hasMore && uplimit_reason.length > 0">
			已加载全部
		</div>

        <div v-if="uplimit_reason && uplimit_reason.length" class="right-axis">
            <div class="axis-item" :class="{ active: idx===activePlateIdx }" v-for="(plate, idx) in uplimit_reason" :key="'axis-' + idx" @click="scrollToPlate(idx)">
                <span class="dot"></span>
                <span class="axis-name">{{ plate.plate_name }}</span>
                <span class="axis-count">{{ (plate.stocks||[]).length }}</span>
            </div>
        </div>
        </div>
</template>

<script>
	import {
		request_zzquant,
		request_zrx
	} from "network/request.js"
	import StockMiniTrend from "../stock/StockMiniTrend"

	export default {
		props: {
			// status_market:{type:Number,default:0}	
		},
		components: {
			// BootstrapTable
			StockMiniTrend
		},
		mounted() {
			request_zrx({
				url: '/open/tradedays'
			}).then(
				res => {
					let days = res['data']['data']
					this.date1 = days[days.length - 1];
				}
			);
			this._onScroll = () => { this.updateActiveByScroll() }
			window.addEventListener('scroll', this._onScroll)
			if(this.showMinChart) {
				this.$nextTick(this.initObserver)
			}
		},
		beforeDestroy(){ 
			if(this._onScroll){ window.removeEventListener('scroll', this._onScroll) }
			if(this.observer){ this.observer.disconnect() }
			if(this.marketObserver){ this.marketObserver.disconnect() }
			this.stopMarketTimer();
		},
		watch: {
			// status_market:this.update_info
			activePlateIdx(val) {
				this.scrollNavToView(val);
			},
			showMinChart(val) {
				if(val) {
					this.$nextTick(this.initObserver)
				} else {
					if(this.observer) {
						this.observer.disconnect()
						this.observer = null
					}
					this.visibleStocks = {}
				}
			},
			showMarket(val) {
				if(val) {
					this.$nextTick(() => {
						this.initMarketObserver();
						this.startMarketTimer();
					});
				} else {
					if(this.marketObserver) {
						this.marketObserver.disconnect();
						this.marketObserver = null;
					}
					this.stopMarketTimer();
					this.activeMarketStocks.clear();
				}
			},
			uplimit_reason() {
				if(this.showMinChart) {
					this.$nextTick(this.initObserver)
				}
				if(this.showMarket) {
					this.$nextTick(this.initMarketObserver);
				}
			}
		},
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
			return {
				date1: today,
				uplimit_reason: [],
				showReason: false,
				showMinChart: false,
				loading: false,
				activePlateIdx: 0,
				visibleStocks: {},
				observer: null,
				page: 1,
				pageSize: 20,
				hasMore: true,
				loadingMore: false,
				stockThemesMap: {},
				showMarket: false,
				marketData: {},
				activeMarketStocks: new Set(),
				marketObserver: null,
				marketTimer: null,
				marketUpdateTimer: null,
			}
		},
        methods: {
			getMarketColor(val) {
				const v = parseFloat(val);
				if(v > 0) return 'text-danger';
				if(v < 0) return 'text-success';
				return 'text-secondary';
			},
            initMarketObserver() {
                if (this.marketObserver) {
                    this.marketObserver.disconnect();
                }
                this.activeMarketStocks.clear();

                // Pre-load first plate stocks
                if (this.uplimit_reason && this.uplimit_reason.length > 0) {
                    const firstPlate = this.uplimit_reason[0];
                    if (firstPlate.stocks) {
                        firstPlate.stocks.forEach(stock => {
                            if (stock.stock_code) {
                                this.activeMarketStocks.add(stock.stock_code);
                            }
                        });
                    }
                }
                // Fetch immediately
                this.fetchMarketData();

                this.marketObserver = new IntersectionObserver((entries) => {
                    let hasNew = false;
                    entries.forEach(entry => {
                        const code = entry.target.dataset.stockCode;
                        if (code) {
                            if (entry.isIntersecting) {
                                if (!this.activeMarketStocks.has(code)) {
                                    this.activeMarketStocks.add(code);
                                    hasNew = true;
                                }
                            } else {
                                this.activeMarketStocks.delete(code);
                            }
                        }
                    });
                    if (hasNew) {
                        this.triggerMarketUpdate();
                    }
                }, { rootMargin: '200px', threshold: 0 });
                
                this.$nextTick(() => {
                    setTimeout(() => {
                        const rows = this.$el.querySelectorAll('.uplimit_reason_row');
                        rows.forEach(el => {
                            this.marketObserver.observe(el);
                        });
                    }, 100);
                });
            },
            triggerMarketUpdate() {
                if (this.marketUpdateTimer) clearTimeout(this.marketUpdateTimer);
                this.marketUpdateTimer = setTimeout(() => {
                    this.fetchMarketData();
                }, 200);
            },
            startMarketTimer() {
                if(this.marketTimer) clearInterval(this.marketTimer);
                this.marketTimer = setInterval(this.fetchMarketData, 30000);
            },
            stopMarketTimer() {
                if(this.marketTimer) {
                    clearInterval(this.marketTimer);
                    this.marketTimer = null;
                }
                if (this.marketUpdateTimer) {
                    clearTimeout(this.marketUpdateTimer);
                    this.marketUpdateTimer = null;
                }
            },
            fetchMarketData() {
                if(this.activeMarketStocks.size === 0) return;
                const codes = Array.from(this.activeMarketStocks);
                request_zzquant({
                    url: '/open/market/real',
                    params: { symbols: codes.join(',') }
                }).then(res => {
                    if(res && res.data && (res.data.code === 200 || res.data.code === 20000) && res.data.data) {
                        const values = res.data.data.values;
                        if (Array.isArray(values)) {
                            values.forEach(item => {
                                let pct = 0;
                                if(item.preclose_px > 0 && item.last_px > 0) {
                                    pct = ((item.last_px - item.preclose_px) / item.preclose_px * 100).toFixed(2);
                                } else if (item.preclose_px > 0 && item.last_px === 0) {
                                    // 停牌或无交易
                                }
                                this.$set(this.marketData, String(item.symbol), pct);
                            });
                        }
                    }
                }).catch(e => console.error(e));
            },
			calculateStockThemes() {
				const map = {};
				const stockReasons = {};
				if (this.uplimit_reason && this.uplimit_reason.length) {
					this.uplimit_reason.forEach(plate => {
						const plateName = plate.plate_name;
						if (plate.stocks && plate.stocks.length) {
							plate.stocks.forEach(stock => {
								const code = stock.stock_code;
								
								// Capture original reason
								if (stockReasons[code] === undefined) {
									const txt = String(stock['reason'] || '').trim();
									if (txt) {
										const i1 = txt.indexOf('；');
										const i2 = txt.indexOf(';');
										let idx = i1>=0 ? i1 : (i2>=0 ? i2 : -1);
										stockReasons[code] = (idx>=0 ? txt.substring(0, idx) : txt).trim();
									} else {
										stockReasons[code] = '';
									}
								}

								if (!map[code]) {
									map[code] = [];
								}
								const cleanPlateName = plateName.trim();
								if (map[code].indexOf(cleanPlateName) === -1) {
									map[code].push(cleanPlateName);
								}
							});
						}
					});
				}
				const finalMap = {};
				Object.keys(map).forEach(code => {
					const plates = map[code];
					const originalReason = stockReasons[code];
					const components = [];
					const candidates = [];
					
					if (originalReason) {
						// Split original reason by '+' to handle pre-combined tags
						const parts = originalReason.split('+');
						parts.forEach(part => {
							const t = part.trim();
							if (t) candidates.push(t);
						});
					}
					
					plates.forEach(p => {
						const t = p.trim();
						if (t) candidates.push(t);
					});

					const seen = new Set();
					candidates.forEach(t => {
						if (seen.has(t)) return;
						
						// Check if any existing component contains t (User req: 前面的题材包含了后面的题材则后面也不显示)
						const isRedundant = components.some(existing => existing.indexOf(t) !== -1);
						
						if (!isRedundant) {
							components.push(t);
							seen.add(t);
						}
					});
					
					finalMap[code] = components.join('+');
				});
				this.stockThemesMap = finalMap;
			},
            initObserver() {
				if (this.observer) {
					this.observer.disconnect();
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							const stockCode = entry.target.dataset.stockCode;
							if (stockCode && !this.visibleStocks[stockCode]) {
								this.$set(this.visibleStocks, stockCode, true);
								this.observer.unobserve(entry.target);
							}
						}
					});
				}, {
					rootMargin: '100px'
				});
				this.observeStockRows();
			},
			observeStockRows() {
				if (!this.observer) return;
				const elements = this.$el.querySelectorAll('.mobile-min-chart-placeholder');
				elements.forEach(el => {
					if (!this.visibleStocks[el.dataset.stockCode]) {
						this.observer.observe(el);
					}
				});
			},
            onDatePicked(ctx) {
                this.date1 = ctx.selectedYMD;
                // console.log(this.date1);
                this.update_info(this.date1);
            },
			show_sidebar(stock_info){
				this.$emit('show_sidebar',stock_info)
			},
			scrollNavToView(idx) {
				try {
					const navBar = this.$refs.mobileNavBar;
					const items = this.$refs.mobileNavItems;
					
					if (!navBar || !items || !items[idx]) return;
					
					const item = items[idx];
					const itemCenter = item.offsetLeft + item.offsetWidth / 2;
					const containerCenter = navBar.offsetWidth / 2;
					
					let scrollLeft = itemCenter - containerCenter;
					
					navBar.scrollTo({
						left: scrollLeft,
						behavior: 'smooth'
					});
				} catch (e) {
					/* ignore */
				}
			},
			scrollToPlate(idx){
				try{
					const el = document.getElementById('plate-' + idx)
					if(el){ el.scrollIntoView({ behavior: 'smooth', block: 'start' }); this.activePlateIdx = idx }
				}catch(e){ /* ignore */ }
			},
			updateActiveByScroll(){
				try{
					const y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
					let idx = 0
					for(let i=0;i<(this.uplimit_reason||[]).length;i++){
						const el = document.getElementById('plate-' + i)
						if(!el) continue
						const top = el.getBoundingClientRect().top + y
						if(top <= y + 120){ idx = i } else { break }
					}
					this.activePlateIdx = idx
				}catch(e){ /* ignore */ }
			},
            amount_display(stocks){
                let rate = Number(stocks && stocks['turnover_ration_real']);
                if(isNaN(rate) || rate===0){ rate = Number((stocks && (stocks['turnover_ration']||stocks['turnover_rate'])) || 0) }
                if(isNaN(rate) || rate===0) return '';
                if(rate<=1) rate = rate*100;
                return new Number(rate).toFixed(2);
            },
			sortedStocks(plate){
				const list = Array.isArray(plate && plate['stocks']) ? plate['stocks'].slice() : [];
				list.sort((a,b)=>{
					const ka = Number(a && a['up_limit_keep_times']) || 0;
					const kb = Number(b && b['up_limit_keep_times']) || 0;
					if(ka!==kb){ return kb - ka }
					const taMin = this.timeToMinutes(a && a['up_limit_time']);
					const tbMin = this.timeToMinutes(b && b['up_limit_time']);
					if(taMin!==tbMin){ return taMin - tbMin }
					const ta = this.theme(a) || '';
					const tb = this.theme(b) || '';
					return ta.localeCompare(tb);
				});
				return list;
			},
			timeToMinutes(t){
				if(!t) return 0;
				const parts = String(t).split(':');
				const h = parseInt(parts[0]||'0',10);
				const m = parseInt(parts[1]||'0',10);
				if(isNaN(h)||isNaN(m)) return 0;
				return h*60+m;
			},
			theme(stocks){
				if (!stocks || !stocks.stock_code) return '';
				return this.stockThemesMap[stocks.stock_code] || '';
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			update_info() {
				this.page = 1
				this.hasMore = true
				this.uplimit_reason = []
				this.loadData()
			},
			downloadData() {
				if (!this.uplimit_reason || !this.uplimit_reason.length) {
					this.$bvToast.toast('暂无数据', { title: '提示', variant: 'warning', solid: true });
					return;
				}

				let csvContent = "\uFEFF";
				csvContent += "板块/题材,股票名称,股票代码,时间,板高度,封单额(亿),成交额(亿),流通市值(亿),换手率,涨停原因\n";

				this.uplimit_reason.forEach(plate => {
					const plateName = (plate.plate_name || '').replace(/,/g, '，');
					const stocks = this.sortedStocks(plate);
					
					stocks.forEach(stock => {
						const row = [
							plateName,
							(stock.stock_name || '').replace(/,/g, '，'),
							stock.stock_code ? String(stock.stock_code) + '\t' : '',
							stock.up_limit_time || '',
							stock.up_limit_desc || '',
							new Number(stock.fengdan_money / 100000000).toFixed(2),
							new Number(stock.amount).toFixed(2),
							new Number(stock.actualcirculation_value / 100000000).toFixed(2),
							this.amount_display(stock),
							'"' + (stock.reason || '').replace(/"/g, '""') + '"'
						];
						csvContent += row.join(',') + "\n";
					});
				});

				const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
				const link = document.createElement("a");
				const url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", `涨停复盘_${this.date1}.csv`);
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			loadData() {
				const isFirstPage = this.page === 1
				if (isFirstPage) {
					this.loading = true
				} else {
					this.loadingMore = true
				}

				request_zzquant({
					url: 'v3/api/review/uplimit/reason?date1=' + this.date1 + '&page=' + this.page + '&page_size=' + this.pageSize,
				}).then(res => {
					const newData = res['data']['data']
					if (isFirstPage) {
						this.uplimit_reason = newData
					} else {
						this.uplimit_reason = this.uplimit_reason.concat(newData)
					}
					
					this.calculateStockThemes()

					if (newData.length < this.pageSize) {
						this.hasMore = false
					} else {
						this.page += 1
					}

					this.loading = false
					this.loadingMore = false
				}).catch(() => {
					this.loading = false
					this.loadingMore = false
				})
			}
		},

	}
</script>

<style>

.uplimit_reason_row{ border-width:0 0 1px 0 !important; }
.uplimit_reason .uplimit_reason-item{ border-top:0 !important; border-bottom:0 !important; }
.uplimit_reason_text{ border-bottom:0 !important; }
.ur-badge{ font-size:12px; height:18px; padding:0 6px; margin:0 6px; line-height:18px; display:inline-flex; align-items:center; justify-content:center; vertical-align:middle; position:relative; top:4px; background-color:transparent !important; border:1px solid #dc3545; color:#dc3545; }
.uplimit_reason_plate{ display:inline-flex; align-items:center; line-height:18px; }
.plate-header{ min-height:22px; }

/* 调整通用标记位置与大小 */
.ur-badge{ top:2px; }
.plate-header .ur-badge{ top:0; }
.right-axis{ position:fixed; right:10px; top:100px; width:160px; max-height:70vh; overflow:auto; background:#fff; border:1px solid #eee; border-radius:4px; padding:6px; }
.axis-item{ display:flex; align-items:center; justify-content:space-between; padding:4px 6px; cursor:pointer; }
.axis-item:hover{ background:#f7f7f7; }
.dot{ width:8px; height:8px; border-radius:50%; background:#bbb; margin-right:6px; display:inline-block; }
.axis-name{ flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; margin-left:4px; }
.axis-count{ color:#999; margin-left:8px; }
.axis-item.active{ background:#fff3cd; }
.axis-item.active .dot{ background:#ffae00; }

@media (max-width: 480px){
  .ur-badge{ font-size:10px; height:16px; line-height:16px; padding:0 4px; top:1px; }
  .right-axis{ display:none; }
  
  .mobile-nav-bar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    padding: 8px 4px;
    background: #fff;
  }
  .mobile-nav-item {
    display: inline-block;
    padding: 4px 12px;
    margin: 0 4px;
    border-radius: 16px;
    background: #f1f1f1;
    font-size: 13px;
    color: #666;
  }
  .mobile-nav-item.active {
    background: #007bff;
    color: #fff;
  }
  
  /* Helper classes for mobile table */
  .scale-8 {
    transform: scale(0.85);
    transform-origin: left center;
    display: inline-block;
  }
  
  .text-truncate-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
  }

  .mobile-stock-row:active {
    background-color: #f8f9fa;
  }
  
  .stock-market-tag {
    font-size: 10px;
    padding: 0 3px;
    border: 1px solid #dc3545;
    color: #dc3545;
    border-radius: 3px;
    margin-left: 4px;
    line-height: 12px;
    display: inline-block;
    vertical-align: 1px;
    font-weight: normal;
  }
  
  .first-board-badge {
    color: #999 !important;
    border-color: #ccc !important;
  }
  
  /* Remove border from the last row in card view if needed, but border-bottom is on wrapper */
}

</style>
